import type { PdfProps } from 'features/reporting/types'
import type { SectionAddendum } from 'pages/reporting/reports/rug/rugReportData'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'

import { AddendumContentPages } from './AddendumContentPages'
import { ImagePageHeader } from './ImagePageHeader'

interface CustomSectionPagesProps extends PdfProps {
  sectionId: string
  sectionTitle: string
  addendums: SectionAddendum[]
}

export const CustomSectionPages: React.FC<CustomSectionPagesProps> = ({
  sectionId,
  sectionTitle,
  addendums,
  onRender,
}) => {
  const { formData, addendumImageSources } = useRugReportOps()
  return (
    <AddendumContentPages
      sectionId={sectionId}
      sectionTitle={sectionTitle}
      addendums={addendums}
      jobNumber={formData.mainInfo.jobNumber}
      revisionNumber={formData.revisionMetadata.revisionNumber}
      imageHeader={<ImagePageHeader />}
      imageSources={addendumImageSources}
      onRender={onRender}
    />
  )
}
